interface Days {
  key: number,
  text: string,
  value?: string
}

interface OperationHour {
  WholeDay: string,
  CustomHours: string
}

interface OperationDay {
  EveryDay: string,
  MonFri: string,
  CustomDays: string
}

export const dayOfWeekOptions: Days[] = [
  { key: 0, text: "Mon", value: "Mon" },
  { key: 1, text: "Tue", value: "Tue" },
  { key: 2, text: "Wed", value: "Wed" },
  { key: 3, text: "Thu", value: "Thu" },
  { key: 4, text: "Fri", value: "Fri" },
  { key: 5, text: "Sat", value: "Sat" },
  { key: 6, text: "Sun", value: "Sun" },
];

export const operationDaysOptionsList: Days[] = [
  { key: 0, text: "Every Day" },
  { key: 1, text: "Mon-Fri" },
  { key: 2, text: "Set Days" },
];

export const operationHoursOptionsList: Days[] = [
  { key: 0, text: "24 Hours" },
  { key: 1, text: "Set Time" },
];

export const operationDaysType: OperationDay = {
  EveryDay: "0",
  MonFri: "1",
  CustomDays: "2",
};

export const operationHoursType: OperationHour = {
  WholeDay: "0",
  CustomHours: "1",
};

export const timeOptions: Days[] = [
  { key: 0, text: "00:00", value: "12:00am" },
  { key: 1, text: "00:30", value: "12:30am" },
  { key: 2, text: "01:00", value: "1:00am" },
  { key: 3, text: "01:30", value: "1:30am" },
  { key: 4, text: "02:00", value: "2:00am" },
  { key: 5, text: "02:30", value: "2:30am" },
  { key: 6, text: "03:00", value: "3:00am" },
  { key: 7, text: "03:30", value: "3:30am" },
  { key: 8, text: "04:00", value: "4:00am" },
  { key: 9, text: "04:30", value: "4:30am" },
  { key: 10, text: "05:00", value: "5:00am" },
  { key: 11, text: "05:30", value: "5:30am" },
  { key: 12, text: "06:00", value: "6:00am" },
  { key: 13, text: "06:30", value: "6:30am" },
  { key: 14, text: "07:00", value: "7:00am" },
  { key: 15, text: "07:30", value: "7:30am" },
  { key: 16, text: "08:00", value: "8:00am" },
  { key: 17, text: "08:30", value: "8:30am" },
  { key: 18, text: "09:00", value: "9:00am" },
  { key: 19, text: "09:30", value: "9:30am" },
  { key: 20, text: "10:00", value: "10:00am" },
  { key: 21, text: "10:30", value: "10:30am" },
  { key: 22, text: "11:00", value: "11:00am" },
  { key: 23, text: "11:30", value: "11:30am" },
  { key: 24, text: "12:00", value: "12:00pm" },
  { key: 25, text: "12:30", value: "12:30pm" },
  { key: 26, text: "13:00", value: "1:00pm" },
  { key: 27, text: "13:30", value: "1:30pm" },
  { key: 28, text: "14:00", value: "2:00pm" },
  { key: 29, text: "14:30", value: "2:30pm" },
  { key: 30, text: "15:00", value: "3:00pm" },
  { key: 31, text: "15:30", value: "3:30pm" },
  { key: 32, text: "16:00", value: "4:00pm" },
  { key: 33, text: "16:30", value: "4:30pm" },
  { key: 34, text: "17:00", value: "5:00pm" },
  { key: 35, text: "17:30", value: "5:30pm" },
  { key: 36, text: "18:00", value: "6:00pm" },
  { key: 37, text: "18:30", value: "6:30pm" },
  { key: 38, text: "19:00", value: "7:00pm" },
  { key: 39, text: "19:30", value: "7:30pm" },
  { key: 40, text: "20:00", value: "8:00pm" },
  { key: 41, text: "20:30", value: "8:30pm" },
  { key: 42, text: "21:00", value: "9:00pm" },
  { key: 43, text: "21:30", value: "9:30pm" },
  { key: 44, text: "22:00", value: "10:00pm" },
  { key: 45, text: "22:30", value: "10:30pm" },
  { key: 46, text: "23:00", value: "11:00pm" },
  { key: 47, text: "23:30", value: "11:30pm" },
  { key: 48, text: "24:00", value: "12:00am" },
];
